import { render, staticRenderFns } from "./TheCallsHistory.vue?vue&type=template&id=67b8c51a&"
import script from "./TheCallsHistory.vue?vue&type=script&lang=js&"
export * from "./TheCallsHistory.vue?vue&type=script&lang=js&"
import style0 from "./TheCallsHistory.vue?vue&type=style&index=0&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports